module.exports = __webpack_public_path__ + "img/snow_fall_00034.2f576009.png";